import HeadTags from 'shared/HeadTags';
import Breadcrumbs from 'shared/Breadcrumbs';
const pdf = require("assets/docs/uvedomlenie_216_11.pdf");

const serv_01 = require("assets/img/serv-item_01.jpg");
const serv_02 = require("assets/img/serv-item_02.jpg");
const serv_03 = require("assets/img/serv-item_03.jpg");
const serv_04 = require("assets/img/serv-item_04.jpg");
const serv_05 = require("assets/img/serv-item_05.jpg");
const serv_06 = require("assets/img/serv-item_06.jpg");
const serv_07 = require("assets/img/serv-item_07.jpg");
const serv_08 = require("assets/img/serv-item_08.jpg");
const serv_09 = require("assets/img/serv-item_09.jpg");
const serv_10 = require("assets/img/serv-item_10.jpg");
const serv_11 = require("assets/img/serv-item_11.jpg");
const serv_12 = require("assets/img/serv-item_12.jpg");

const NewCatalog = () => {
    return (
        <div className="allservice serv-cat">
            <HeadTags
                title='Услуги салона красоты в Брянске'
                metaDescription='Каталог услуг'
            />
            <div className="container">
                <Breadcrumbs pageName={'Каталог услуг'}/>
                <h1>Каталог услуг</h1>
                <div className="allservice_links">
                    <a className="allservice_pdf" href={pdf} target="_blank" rel="noopener noreferrer">Обучение "Салонные стрижки", "Макияж для&nbsp;себя"</a>
                </div>
                <ul className="serv-list">
                    {/* тут нужны будут динамические классы для 'serv-item' класс-модификатор 'serv-item--short' */}
                    <li className="serv-item">
                        <a href="#" className="serv-item_link">
                            <span>Косметология</span>
                            <img src={serv_01} alt="Косметология" title="Косметология" />
                        </a>
                        <ul className="serv-item_list">
                            <li><a href="#">Эстетическая (чистки, пилинги, уходы)</a></li>
                            <li><a href="#">Иньекционная</a></li>
                            <li><a href="#">Аппаратная (лазерное омоложение, RF,<br/> эндосфератерапия лицо)</a></li>
                        </ul>
                    </li>
                    <li className="serv-item">
                        <a href="#" className="serv-item_link">
                            <span>Эстетика тела (аппаратные методики)</span>
                            <img src={serv_02} alt="Эстетика тела (аппаратные методики)" title="Эстетика тела (аппаратные методики)" />
                        </a>
                        <ul className="serv-item_list">
                            <li><a href="#">Эндосфератерапия тела</a></li>
                            <li><a href="#">LPG</a></li>
                            <li><a href="#">LPG Cellu M6 Alliance</a></li>
                            <li><a href="#">LPG Cellu M6 Keymodule</a></li>
                            <li><a href="#">Коррекция фигуры и сжигание жира на аппарате KN Magnetic</a></li>
                            <li><a href="#">Прессотерапия</a></li>
                        </ul>
                    </li>
                    <li className="serv-item">
                        <a href="#" className="serv-item_link">
                            <span>Эстетика тела (ручные техники)</span>
                            <img src={serv_03} alt="Эстетика тела (ручные техники)" title="Эстетика тела (ручные техники)" />
                        </a>
                        <ul className="serv-item_list">
                            <li><a href="#">Массаж</a></li>
                            <li><a href="#">Обертывания</a></li>
                            <li><a href="#">Массаж лица и кожи головы</a></li>
                            <li><a href="#">Массаж "Афродита"</a></li>
                            <li><a href="#">Медовый массаж</a></li>
                            <li><a href="#">Антицеллюлитный массаж</a></li>
                            <li><a href="#">Акупунктурный массаж</a></li>
                            <li><a href="#">Спортивный массаж</a></li>
                            <li><a href="#">Массаж "Бразильская попа"</a></li>
                            <li><a href="#">Лимфодренажный массаж</a></li>
                        </ul>
                    </li>
                    <li className="serv-item">
                        <a href="#" className="serv-item_link">
                            <span>СПА процедуры</span>
                            <img src={serv_04} alt="СПА процедуры" title="СПА процедуры" />
                        </a>
                        <ul className="serv-item_list">
                            <li><a href="#">СПА-релакс (ритуал для лица, волос и головы)</a></li>
                            <li><a href="#">Душ Шарко</a></li>
                        </ul>
                    </li>
                    <li className="serv-item">
                        <a href="#" className="serv-item_link">
                            <span>Ритуалы La Sultane de&nbsp;Saba</span>
                            <img src={serv_05} alt="Ритуалы La Sultane de Saba" title="Ритуалы La Sultane de Saba" />
                        </a>
                        <ul className="serv-item_list">
                            <li><a href="#">Восточный уход с ароматом Аюрведа</a></li>
                            <li><a href="#">Церемония "Оазис"</a></li>
                            <li><a href="#">Спа для рук/ног</a></li>
                            <li><a href="#">Домашний уход</a></li>
                        </ul>
                    </li>
                    <li className="serv-item">
                        <a href="#" className="serv-item_link">
                            <span>Парикмахерские услуги</span>
                            <img src={serv_06} alt="Парикмахерские услуги" title="Парикмахерские услуги" />
                        </a>
                        <ul className="serv-item_list">
                            <li><a href="#">Стрижки</a></li>
                            <li><a href="#">Укладки и прически</a></li>
                            <li><a href="#">Окрашивание LOREAL, WELLA, MATRIX</a></li>
                            <li><a href="#">Восстановление волос HADAT</a></li>
                            <li><a href="#">Восстановление волос QTEM</a></li>
                            <li><a href="#">Кератиновое выпрямление</a></li>
                        </ul>
                    </li>
                    <li className="serv-item">
                        <a href="#" className="serv-item_link">
                            <span>Ногтевой сервис</span>
                            <img src={serv_07} alt="Ногтевой сервис" title="Ногтевой сервис" />
                        </a>
                        <ul className="serv-item_list">
                            <li><a href="#">Маникюр</a></li>
                            <li><a href="#">Педикюр</a></li>
                            <li><a href="#">Парафинотерапия</a></li>
                        </ul>
                    </li>
                    <li className="serv-item serv-item--short">
                        <a href="#" className="serv-item_link">
                            <span>Брови и&nbsp;ресницы</span>
                            <img src={serv_08} alt="Брови и ресницы" title="Брови и ресницы" />
                        </a>
                    </li>
                    <li className="serv-item serv-item--short">
                        <a href="#" className="serv-item_link">
                            <span>Макияж</span>
                            <img src={serv_09} alt="Макияж" title="Макияж" />
                        </a>
                    </li>
                    <li className="serv-item serv-item--short">
                        <a href="#" className="serv-item_link">
                            <span>Депиляция воск/сахар</span>
                            <img src={serv_10} alt="Депиляция воск/сахар" title="Депиляция воск/сахар" />
                        </a>
                    </li>
                    <li className="serv-item serv-item--short">
                        <a href="#" className="serv-item_link">
                            <span>Солярий-коллариум</span>
                            <img src={serv_11} alt="Солярий-коллариум" title="Солярий-коллариум" />
                        </a>
                    </li>
                    <li className="serv-item">
                        <a href="#" className="serv-item_link">
                            <span>Подарочные сертификаты</span>
                            <img src={serv_12} alt="Подарочные сертификаты" title="Подарочные сертификаты" />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default NewCatalog;